import _extends from "@babel/runtime/helpers/extends";
var _StyledDropdownDownIc;
import React from 'react';
import styled, { css } from 'styled-components';
import { ICON_TINY_SIZE, INFO_WITH_ICONS_TINY_MARGIN } from '../../constants';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED, ELEMENT_GRAY, SENSATION_WHITE } from '../../colors';
import DropdownDownIcon from '@tourlane/iconography/Glyphs/Navigation/DropdownDown';
import InfoButton from './InfoButton';
import IconWithRotation from '../../SvgIcon/IconWithRotation';
import { omitProps } from '../../helpers/elements';
import InfoWithIconsSimple from '../InfoWithIcons/InfoWithIconsSimple';
const StyledDropdownDownIcon = styled(DropdownDownIcon)``; // Workaround to be able to style inner SVG
const StyledInfoButton = styled(omitProps((props, ref) => /*#__PURE__*/React.createElement(InfoButton, _extends({
  ref: ref
}, props)), ['iconColor', 'iconColorDisabled', 'iconColorHover', 'iconColorActive']))`
  ${({
  disabled
}) => disabled && `cursor: not-allowed;`}
  ${({
  disabled,
  iconColorHover,
  iconColorActive
}) => !disabled && css`
      &:hover {
        ${StyledDropdownDownIcon} {
          fill: ${iconColorHover};
        }
      }
      &:active {
        ${StyledDropdownDownIcon} {
          fill: ${iconColorActive};
        }
      }
    `}
`;
const InfoButtonWithDropdown = /*#__PURE__*/React.forwardRef(({
  inverse = false,
  rotated = false,
  disabled = false,
  iconSize = ICON_TINY_SIZE,
  iconMargin = INFO_WITH_ICONS_TINY_MARGIN,
  iconColor: iconColorProp,
  iconColorHover = ADVENTURE_GREEN,
  iconColorActive = ADVENTURE_GREEN_FOCUSED,
  iconColorDisabled = ELEMENT_GRAY,
  children,
  ...props
}, forwardedRef) => {
  const iconColor = iconColorProp ?? (inverse ? SENSATION_WHITE : ELEMENT_GRAY);
  return /*#__PURE__*/React.createElement(StyledInfoButton, _extends({
    noFocus: true,
    clickable: !disabled,
    ref: forwardedRef,
    disabled: disabled,
    iconColor: iconColor,
    iconColorHover: iconColorHover,
    iconColorActive: iconColorActive,
    iconColorDisabled: iconColorDisabled
  }, props), /*#__PURE__*/React.createElement(InfoWithIconsSimple, {
    iconRight: /*#__PURE__*/React.createElement(IconWithRotation, {
      pointer: !disabled,
      rotated: rotated,
      size: iconSize,
      icon: _StyledDropdownDownIc || (_StyledDropdownDownIc = /*#__PURE__*/React.createElement(StyledDropdownDownIcon, null)),
      color: disabled ? iconColorDisabled : iconColor,
      colorHover: disabled ? iconColorDisabled : iconColorHover
    }),
    iconRightMargin: iconMargin
  }, children));
});
export default InfoButtonWithDropdown;